export const documentsPickerCheckboxSx = {
  p: 0.25,
  color: 'var(--app-text-secondary)',
  '&.Mui-checked': {
    color: 'var(--app-accent-primary)',
  },
}
